import React from "react";
import TlkTable from "../../../components/tlelrik/table/tlkTable";
import services from "../../../services";
import queryString from "query-string";
import moment from "moment";
import $ from "jquery";

let listdefaultRequest = {
    Filters: null,
    SortBy: "",
    IsSortTypeDESC: true,
    IsPagination: true,
    //Page: 1,
    PageSize: 100,
};

const dateFormat = "DD-MM-YYYY HH:mm:ss";

let tablesjson = {
    TransferenciasRotulosTable: {
        columnkeyMap: {
            numeroPedido: "Número Pedido",
            entidade: "Entidade",
            numeroRegistoOrigem: "Número Registo Origem",
            numeroRegistoDestino: "Número Registo Destino",
            estado: "Estado",
            observacoes : "Fundamentação da decisão"
        },
       
        listApilink: "Rotulos/ViewRotulosTransferencias",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de transferências pendentes ",
        Filters: {
            codEstado: 1
        },
        actionbuttons: { TranferenciasDetalhe: "TranferenciasDetalhe" },
        groupfield: [],
        filters: {
            codEstado: 1
        }
    },
}


class TransferenciasRotulos extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            linkData: tablesjson[this.props.tableName],
            telkikTable: null,
            popUpForm: null,
            tlkState: null,
            error: null,
            showSearchMsg: false,
            totalcount: 0,
        };
    }

    componentDidMount() {
       
        console.log("OI");
        this.defaultState();
    }

    componentDidUpdate = (preProp) => {
        if (
            preProp.date !== this.props.date ||
            preProp.tableName !== this.props.tableName
        ) {
         
            this.defaultState();
        }
    };

    defaultState = () => {
        let linkData = { ...tablesjson };
        linkData = tablesjson[this.props.tableName];
        console.log("OI 2");
        this.setState(
            {
                linkData: linkData,
                tlkState: {
                    take: 20,
                    skip: 0,
                    group: [],
                    exporting: false,
                },
            },
            () => this.getListData()
        );
    };
    
    getAllFilter = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        Request.Filters = { ...Request.Filters, ...this.props.applyedfilter };
        if (
            Request.Filters.entityId === undefined ||
            Request.Filters.entityId === ""
        ) {
            Request.Filters.entityId = null;
        }
        if (
            Request.Filters.entityname === undefined ||
            Request.Filters.entityname === ""
        ) {
            Request.Filters.entityname = null;
        }
        Request = { ...Request.Filters };
        return Request;
    };

    getListData = async () => {
        try {
            console.log("OI 3");
            if (!this.state.linkData) return;
            console.log("OI 4");
            let Request = this.getAllFilter();
            if (this.state.linkData.singleEntity) {
                this.setState({
                    totalcount: 0,
                    telkikTable: null,
                });
            }
            
            let method = this.state.linkData.requestMethod;
            let link = this.state.linkData.listApilink;
            let columnkeyMap = this.state.linkData.columnkeyMap;
            let res = {};
            console.log("MOVS PENDENTES");
            console.log(link);
            console.log(Request);
            console.log(method);
            res = await services.apiCall.requestApi(link, Request, method);
            console.log("ressspnseeeee", res);
            if (res && res.length > 0) {
                res.map((_row, index) => {
                    Object.keys(columnkeyMap).map(function (key) {
                        //console.log(_row, "ROWS Fisc")
                        if (key === "dataCriado") {
                                _row[columnkeyMap[key]] = _row.dataCriado
                                    ? moment(_row.dataCriado).format(
                                        dateFormat
                                      )
                                    : "nd";
                            }else{
                                _row[columnkeyMap[key]] = _row[key] || "nd";
                        }
                        
                    });
                });
                // console.log("Akash", "1", res);
                window.localStorage.setItem('table_total', res.length);
                this.setState(
                    {
                        data: res,
                        filterData: res,
                        showSearchMsg: false,
                        totalcount: window.localStorage.getItem("table_total"),
                    },
                    () => {
                        // console.log("Akash", "2");
                        this.createTabel();
                    }
                );
            } else {
                this.setState({
                    showSearchMsg: true,
                    totalcount: 0,
                    telkikTable: null,
                });
            }
        } catch (error) {
            this.setState({ error });
        }
    };
    // ActionPerform = (action, row) => {
    //     if (this.props.actionPerform) {
    //         this.props.actionPerform(action, row);
    //     }
    // };
    createTabel = () => {
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = { ...this.state.linkData.columnkeyMap };
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: "checkbox" };
            });
            let actionbuttons = this.state.linkData.actionbuttons || {};
            let telkikTable = (
                <TlkTable
                    date={new Date()}
                    noDownloadButton={this.state.linkData.noDownloadButton}
                    actionColumnName={this.state.linkData.actionColumnName}
                    groupfield={this.state.linkData.groupfield}
                    modulename={this.state.linkData.modulename || "fordefault"}
                    notAction={this.state.linkData.notAction}
                    tlkState={this.state.tlkState}
                    // deleteFunc={(id) => this.props.handleDelete(id)}
                    tableFilters={(filter) => this.tableFilters(filter)}
                    list={this.state.filterData}
                    actionbuttons={actionbuttons}
                    MainModule="tranferencias"
                    columnlist={columnlist}
                    ActionPerform={(action, id) =>
                        this.ActionPerform(action, id)
                    }
                />
            );
            this.setState({
                telkikTable: telkikTable,
            });
        }
    };
    ActionPerform = async (action, row) => {
        console.log("entou no action" , action)
        // TODO: Rohit — Export data from grid
        if (action === "TranferenciasDetalhe") {
            console.log("row is here, ", row)
            const queryParams = queryString.stringify({
                idPedidoTransferencia: row.detalheURL,
                estado: row.estado,
                idEntidade : row.detalheURLIDEntidade
            })
            
            window.location.href = `/Detalhes_Transferencia?${queryParams}`
            // });
        }
    }

    /* Obter filtros aplicados na tabela para atualização dinâmica */
    tableFilters = (tlfilter) => {
        // console.log("tlfilter",tlfilter);
        try {
            let customfilters = this.getAllFilter();
            let columnkeyMap = this.state.linkData.columnkeyMap;
            let tlkState = { ...tlfilter };
            let data = this.makeTlkFilters(
                tlfilter,
                columnkeyMap,
                customfilters
            );
            let linkData = { ...this.state.linkData };

            // linkData.Filters = data.Filters
            this.setState(
                {
                    tlkState,
                    linkData,
                },
                () => this.getListData()
            );
        } catch (error) {
            this.setState({ error: error });
        }
        // return data;
    };

    /* Alterações de filtro de tabela em formatos de API */
    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let tlkState;
        let inFilters = {};
        let columnkeyMaprev = {};
        // console.log("-----------pppppppppp",columnkeyMap)
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (
            tlkfilter.filter &&
            tlkfilter.filter.filters &&
            tlkfilter.filter.filters.length > 0
        ) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        _srow.value = _srow.value ? _srow.value : "";
                        checkamount = _srow.value.split(" ");
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value)
                            ? Number(_srow.value)
                            : _srow.value;
                        tkkeyvalues.push(_srow.value);
                    });
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            });
        }
        let defaultRequest = listdefaultRequest;
        defaultRequest.Page = tlkfilter.skip
            ? tlkfilter.skip / tlkfilter.take + 1
            : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC =
                tlkfilter.sort[0].dir === "asc" ? false : true;
        }
        // data.inFilters = inFilters;
        return data;
    };

    /*  Para realizar a ação com base na seleção da tabela  */

    // ActionPerform = (action, row) => {
    //     if (this.props.ActionPerform) {
    //         this.props.ActionPerform(action, row);
    //     } else {
    //         let popUpForm = null;
    //     }
    // };

    // selectionChange(selection) {
    //     const data = [...this.state.data].map((item) => {
    //         if (
    //             selection.dataItem.codInstalacaoVinica ===
    //             item.codInstalacaoVinica
    //         ) {
    //             // TODO: Ask @Dart for the unique key to use here
    //             return { ...item, selected: true };
    //         } else {
    //             return { ...item, selected: false };
    //         }
    //     });
    //     this.setState({ data }, async () => {
    //         const queryParams = queryString.stringify({
    //             ...queryString.parse(this.props.location.search),
    //             installationId: 0,
    //         });
    //         this.props.history.push(
    //             `/conta_corrente/accounts_view?${queryParams}`
    //         );
    //     });
    // }

    

    render() {
        return (
            <div className="custom-k-grid table-section">
                <div className="table-responsive">
                    {this.state.telkikTable && (
                        <>
                            <h3>
                                {tablesjson[this.props.tableName] &&
                                tablesjson[this.props.tableName]
                                    .totalPageHeading
                                    ? tablesjson[this.props.tableName]
                                          .totalPageHeading +
                                      "(" +
                                      this.state.totalcount +
                                      ")"
                                    : `A pesquisa retornou ${this.state.totalcount} registos`}
                            </h3>
                            {this.state.telkikTable}
                        </>
                    )}
                    {this.state.totalcount == 0 && (
                        <div className="searct-found">
                            <img className="img-fluid" src="imgs/data-rotulos.png" alt="Não foram identificados registos com os critérios indicados" />
                            {this.state.showSearchMsg ? (
                                <p className="font-14">Não foram identificados registos com os critérios indicados</p>
                            ) : (
                                <h3>
                                    Pesquise uma instalação ou entidade para
                                    apresentação de mais informações
                                </h3>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default TransferenciasRotulos;
